import Vue from 'src/views/base'
import { Component, Prop } from 'vue-property-decorator'
import template from './content-layout.vue'

@Component({
    name: 'content-layout',
    mixins: [ template ]
})
export default class ContentLayout extends Vue {
    @Prop({ type: String }) navTitle
    @Prop({ type: String }) rowTitle
}



// WEBPACK FOOTER //
// ./src/views/components/content-layout/index.js